export default __webpack_public_path__ + "static/media/yuk-travel.0f694f46.png";